<app-default-card [title]="'Geschäftspartner'" *ngIf="initialBPOptions$ | async as initialBPOptions">
  <!-- Wenn ein GP ausgewählt wurde -->
  <ng-container *ngIf="this.selectedBusinessPartner">
    <mat-card style="margin: 1em">
      <mat-card-header>
        <mat-card-content>
          <strong>
            {{ this.selectedBusinessPartner.name }}
            - {{ this.selectedBusinessPartner.customerNo || 'Neu' }}
            {{ this.selectedBusinessPartner.isDeleted ? '(Gelöscht)' : '' }}
          </strong>
          <br />
          {{
            this.selectedBusinessPartner.street +
              ', ' +
              this.selectedBusinessPartner.zipCode +
              ' ' +
              this.selectedBusinessPartner.city || ''
          }}
        </mat-card-content>
      </mat-card-header>
    </mat-card>

    <div class="actions" [style.flex-wrap]="'wrap'">
      <app-custom-button
        color="primary"
        (click)="selectedBusinessPartner = null; manualSelection = true"
        title="Anderen Geschäftspartner auswählen"></app-custom-button>
    </div>
  </ng-container>

  <ng-container *ngIf="!this.selectedBusinessPartner">
    <ng-container *ngIf="initialBPOptions.length > 0 && !manualSelection">
      <div>Es wurden mögliche Dubletten gefunden.</div>

      <mat-card style="margin: 1em" *ngFor="let option of initialBPOptions">
        <mat-card-header>
          <mat-card-content>
            <strong>
              {{ option.name }}
              - {{ option.customerNo }}
            </strong>
            {{ option.isDeleted ? '(Gelöscht)' : '' }}
            <br />
            {{ option.street + ', ' + option.zipCode + ' ' + option.city || '' }}

            <!-- Button zur Übernahme -->
            <button mat-raised-button color="primary" (click)="selectBusinessPartner(option)">
              Auswählen
            </button>
          </mat-card-content>
        </mat-card-header>
      </mat-card>

      <div class="actions" [style.flex-wrap]="'wrap'">
        <app-custom-button
          color="primary"
          (click)="manualSelection = true"
          title="Anderen Geschäftspartner suchen"></app-custom-button>
      </div>
    </ng-container>

    <ng-container *ngIf="manualSelection">
      <form-row>
        <mat-form-field appearance="outline" fxFlex="100" class="search-field">
          <mat-label>Auftragnehmer</mat-label>
          <input type="text" matInput [matAutocomplete]="gpAutocomplete" [formControl]="searchControl" />
          <mat-autocomplete #gpAutocomplete="matAutocomplete">
            <div class="select-elements">folgende Geschäftspartner wurden für ihre Suche gefunden.</div>
            <mat-option
              style="padding: 0.5em; border-bottom: 1px solid #e0e0e0"
              *ngFor="let option of bpOptions$ | async"
              [value]="option.customerNo"
              (onSelectionChange)="$event.source.selected == true && selectBusinessPartner(option)">
              <strong>{{ option.customerNo }} {{ option.name }}</strong>
              {{ option.isDeleted ? '(Gelöscht)' : '' }}
              <br />
              {{ option.street + ', ' + option.zipCode + ' ' + option.city }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </form-row>
    </ng-container>

    <div class="actions" [style.flex-wrap]="'wrap'">
      <app-custom-button color="primary" title="Mit ausgewähltem Kunden fortfahren"></app-custom-button>
      <app-custom-button
        color="primary"
        title="Neuen Geschäftspartner aus Vorgang anlegen"
        (onClick)="useCustomerAsNewBusinessPartner()"></app-custom-button>
    </div>
  </ng-container>
</app-default-card>

<app-default-card title="Auftragspositionen">
  <!--<app-custom-button color='primary' title='Aus Inbetriebnahme-Antrag herleiten'></app-custom-button>-->

  <section>
    <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="erp-order-positions">
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Position</th>
        <td mat-cell *matCellDef="let position" class="no-bottom-border">{{ position.name }}</td>
      </ng-container>

      <!-- Amount Column -->
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Betrag</th>
        <td mat-cell *matCellDef="let position" class="no-bottom-border">
          {{ position.amount | currency : 'EUR' }}
        </td>
      </ng-container>

      <!-- Tax Column -->
      <ng-container matColumnDef="tax">
        <th mat-header-cell *matHeaderCellDef>Steuersatz</th>
        <td mat-cell *matCellDef="let position" class="no-bottom-border">{{ position.tax }} %</td>
      </ng-container>

      <!-- External Id Column -->
      <ng-container matColumnDef="externalId">
        <th mat-header-cell *matHeaderCellDef>Externe Id</th>
        <td mat-cell *matCellDef="let position" class="no-bottom-border">{{ position.externalId }}</td>
      </ng-container>

      <!-- Remove Position Column -->
      <ng-container matColumnDef="remove">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element; let i = dataIndex" [attr.rowspan]="2">
          <button mat-icon-button color="warn" (click)="deletePosition(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Additional Text Column -->
      <ng-container matColumnDef="additionalText">
        <td mat-cell *matCellDef="let position" [attr.colspan]="3">
          <mat-form-field appearance="outline">
            <mat-label>Zusätzlicher Text</mat-label>
            <textarea [(ngModel)]="position.additionalText" matInput></textarea>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Filler Cell -->
      <ng-container matColumnDef="fillerCell">
        <td mat-cell *matCellDef="let position"></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: ['fillerCell', 'additionalText']"></tr>
    </table>

    <!--
    <br />
    <br />
    <br />
    <ng-template [ngForOf]="order?.positions" let-i="index" let-position ngFor>
      <div fxLayout="row" fxLayoutGap="1em">
        <mat-form-field appearance="outline" fxFlex="48">
          <mat-label>Positionstext</mat-label>
          <input [(ngModel)]="position.name" (ngModelChange)="updateTotal()" matInput type="text" />
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="15">
          <mat-label>Betrag</mat-label>
          <input [(ngModel)]="position.amount" (ngModelChange)="updateTotal()" matInput type="number" />
          <span matTextSuffix>€</span>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="12">
          <mat-label>Steuersatz</mat-label>
          <input [(ngModel)]="position.tax" (ngModelChange)="updateTotal()" matInput type="number" />
          <span matTextSuffix>%</span>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="25">
          <mat-label>Externe-Id</mat-label>
          <input [(ngModel)]="position.externalId" (ngModelChange)="updateTotal()" matInput type="text" />
        </mat-form-field>

        <span style="margin-top: 5px">
          <button mat-icon-button color="warn" (click)="deletePosition(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </span>
      </div>
    </ng-template>
    -->

    <button mat-button color="primary" [matMenuTriggerFor]="menu" class="text-with-icon">
      <span class="material-symbols-outlined notranslate">add</span>
      Position hinzufügen
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item *ngFor="let option of lineItemOptions$ | async" (click)="addPosition(option)">
        {{ option.customAttributes.GSBER }} - {{ option.name }}
      </button>
    </mat-menu>

    <!--
    <button mat-raised-button color="primary" (click)="addPosition()">Position hinzufügen</button>
    -->
  </section>

  <section>
    <!--
    <mat-divider style="margin-bottom: 1.4em"></mat-divider>
    -->

    <!--<table>
      <tr>
        <th>Netto:</th>
        <td class="value-text align-right">
          {{ order?.totalPriceNetto | currency : 'EUR' }}
        </td>
      </tr>
      <ng-template [ngForOf]="order?.mwstGrouped" let-i="index" let-mwstGroup ngFor>
        <tr>
          <th>{{ mwstGroup.percentage }}% Mwst:</th>
          <td class="value-text align-right">
            {{ mwstGroup.amount | currency : 'EUR' }}
          </td>
        </tr>
      </ng-template>
      <tr>
        <th>Brutto (inkl. MwSt.):</th>
        <td class="value-text align-right">
          {{ order?.totalPriceBrutto | currency : 'EUR' }}
        </td>
      </tr>
    </table> -->
  </section>
</app-default-card>

<app-default-card [type_class]="'aligner'">
  <app-dynamic-action-button-row [actions]="actions" [alignActions]="'end'"></app-dynamic-action-button-row>
  <app-custom-button
    (onClick)="createOrder()"
    color="primary"
    title="Auftrag erzeugen"
    [disable]="!selectedBusinessPartner"
    infoInButton="Bitte zuerst oben einen Geschäftspartner auswählen."></app-custom-button>
</app-default-card>
